import actionTypes from 'constants/actionTypes'

interface EditState {
  isEditing: boolean
  save: boolean
}

interface EditAction {
  type: string
  payload?: {
    save?: boolean
  }
}

const initialState: EditState = {
  isEditing: false,
  save: false,
}

const edit = (state: EditState = initialState, action: EditAction): EditState => {
  switch (action.type) {
    case actionTypes.GRAPH.EDIT.START:
      return {
        isEditing: true,
        save: false
      }
    case actionTypes.GRAPH.EDIT.STOP:
      return {
        isEditing: false,
        save: Boolean(action.payload?.save)
      }
    case actionTypes.NODES.ONE.EDIT.REQUEST:
    case actionTypes.EDGES.ONE.EDIT.REQUEST:
      return {
        isEditing: state.isEditing,
        save: false
      }
    default:
      return state
  }
}

export default edit
